import MyService from '../../service';

const OptionApi = {
  getAllOption: async () => {
    let result = null;

    await MyService.getRequestData('/option')
      .then((res) => (result = res.data))
      .catch((err) => console.log(err));
    return result;
  },
};
export default OptionApi;
